import styled from "styled-components";

export const StyledMainContentWrapper = styled.div`
    padding: 50px;
`;